import React, { useContext, useRef } from "react";

import {
  ContainerVideo,
  ContainerVideoHeader,
  ContainerVideoAction,
  ContainerVideoHeaderButtonIcon,
  ContainerVideoVideo,
  ModalContainerHeaderButtonIcon
} from "./styled";

import ModalWrapper from "../Wrapper";
import CardChatSupport from "components/Cards/ChatSupport";
import { Col, Row } from "reactstrap";

import Button from "components/Form/Button";
import { CoreContext } from "context/CoreContext";
import { parseStrapiImage } from "utils";

export default function ModalChat() {
  const { modal, setModal } = useContext(CoreContext);

  const close = () => {
    setModal(null);
  };

  const videoRef = useRef(null);

  return (
    <>
      <ModalWrapper headerActions={false}>
        <Row className="justify-content-center">
          <Col
            md={6}
            className="no-col"
            style={{
              overflow: "hidden",
              background: "#fff",
              height: "80vh"
            }}
          >
            <ContainerVideo image={modal?.item?.file?.url}>
              <ContainerVideoHeader>
                <ContainerVideoAction>
                  <Button
                    nospace
                    primary
                    onClick={
                      modal?.item?.file?.url
                        ? () =>
                          window.open(
                            parseStrapiImage(modal?.item?.file?.url),
                            "campaing-asset"
                          )
                        : null
                    }
                    marginLeft={"12px"}
                    sx={{ maxWidth: 332 }}
                  >
                    <ContainerVideoHeaderButtonIcon
                      icon={"cloud-download-white"}
                    />
                    {modal?.item?.isVideo ? `DOWNLOAD DO VÍDEO` : `DOWNLOAD`}
                  </Button>

                  {/* <Button primary nospace onClick={close} sx={{ width: 50, marginLeft: 2 }}>
                    <ModalContainerHeaderButtonIcon icon={"close-white"} />
                  </Button> */}
                </ContainerVideoAction>
              </ContainerVideoHeader>

              {modal?.item?.isVideo ? (
                <>
                  <ContainerVideoVideo
                    ref={videoRef}
                    controls
                    style={{
                      width: "100%",
                      height: "100%",
                      objectFit: "cover"
                    }}
                  >
                    <source
                      src={parseStrapiImage(modal?.item?.file?.url)}
                      type="video/mp4"
                    />
                  </ContainerVideoVideo>
                </>
              ) : null}

              {/* <ContainerVideoBody>

                                <ContainerVideoBodyAction>
                                    <ContainerVideoBodyActionIcon icon={"play"} />
                                </ContainerVideoBodyAction>

                            </ContainerVideoBody>
                            <ContainerVideoFooter>

                                <ContainerVideoFooterProgress>
                                    <ContainerVideoFooterProgressText>0:10</ContainerVideoFooterProgressText>
                                    <ContainerVideoFooterProgressLine>
                                        <ContainerVideoFooterProgressLineDecoration />
                                        <ContainerVideoFooterProgressLineIndicator />
                                    </ContainerVideoFooterProgressLine>
                                    <ContainerVideoFooterProgressText>1:10</ContainerVideoFooterProgressText>
                                </ContainerVideoFooterProgress>

                            </ContainerVideoFooter> */}
            </ContainerVideo>
          </Col>
          <Col className="no-col">
            <CardChatSupport closeable={close} item={modal?.item} />
          </Col>
        </Row>
      </ModalWrapper>
    </>
  );
}
